import { combineReducers } from 'redux';
import buttonStateByCId from './buttonStateByCId';

export default combineReducers({
  buttonStateByCId,
});



// WEBPACK FOOTER //
// ./src/redux/modules/index.js